// plan-11 S05: online/offline detection — bible §28, §39

import { emit } from './bus'

type NetworkState = 'online' | 'offline'

let state: NetworkState = navigator.onLine ? 'online' : 'offline'
let dexscreenerFailureCount = 0
let failureWindowStart = 0
const FAILURE_THRESHOLD = 3
const FAILURE_WINDOW_MS = 60_000

export function getNetworkState(): NetworkState {
  return state
}

export function reportDexscreenerFailure(): void {
  const now = Date.now()
  if (now - failureWindowStart > FAILURE_WINDOW_MS) {
    failureWindowStart = now
    dexscreenerFailureCount = 0
  }
  dexscreenerFailureCount++
  if (dexscreenerFailureCount >= FAILURE_THRESHOLD && state === 'online') {
    goOffline()
  }
}

export function reportDexscreenerSuccess(): void {
  dexscreenerFailureCount = 0
  // if we were offline due to failures and network is back, restore
  if (state === 'offline' && navigator.onLine) {
    goOnline()
  }
}

function goOffline(): void {
  if (state === 'offline') return
  state = 'offline'
  emit('network:offline', {})
}

function goOnline(): void {
  if (state === 'online') return
  state = 'online'
  emit('network:online', {})
}

export function initNetwork(): void {
  window.addEventListener('online', () => {
    if (state === 'offline') {
      goOnline()
    }
  })

  window.addEventListener('offline', () => {
    if (state === 'online') {
      goOffline()
    }
  })

  // set initial state
  if (!navigator.onLine) {
    state = 'offline'
  }
}
